import { JSX } from 'solid-js';
import { CameraMode, UvCameraControlSelector } from './UvCameraControlSelector';
import {
  AlignmentNavigationCapability,
  FreeViewCapability,
  FreeViewMode,
} from '@trimble/web3d-capabilities';
import { UnreachableCaseError } from 'ts-essentials';
import { NotificationEventBus } from '@trimble/solidjs-notifications';
import { t } from '@trimble/i18n';

export const CameraControlSelector = (props: {
  alignmentNavigationCapability: AlignmentNavigationCapability;
  freeViewCapability: FreeViewCapability;
  hiddenModes?: CameraMode[]; // modes that are not allowed to be selected that should be hidden from the selector
}): JSX.Element => {
  const handleCameraSelected = (mode: CameraMode): boolean => {
    const alignmentCap = props.alignmentNavigationCapability;
    const freeViewCap = props.freeViewCapability;

    switch (mode) {
      case 'rotate':
      case 'pan':
      case 'lookAround':
        freeViewCap.enable();
        freeViewCap.activate();
        freeViewCap.setMode(
          mode === 'rotate'
            ? FreeViewMode.Rotate
            : mode === 'pan'
              ? FreeViewMode.Pan
              : FreeViewMode.LookAround
        );

        return true;
      case 'pathNavigation':
        if (!alignmentCap.isEnabled()) {
          NotificationEventBus.emit({
            type: 'info',
            message: t('general.messages.modelSelectionRequired'),
          });
        }
        if (!alignmentCap.isActive()) {
          void alignmentCap.toggleAlignmentNavigationTool(false);
        } else {
          alignmentCap.setCrossSectionEnabled(false);
        }
        return true;
      case 'profileView':
        if (!alignmentCap.isEnabled()) {
          NotificationEventBus.emit({
            type: 'info',
            message: t('general.messages.modelSelectionRequired'),
          });
        }
        if (!alignmentCap.isActive()) {
          void alignmentCap.toggleAlignmentNavigationTool(true);
        } else {
          alignmentCap.setCrossSectionEnabled(true);
        }
        return true;
      default:
        throw new UnreachableCaseError(mode);
    }
  };

  return (
    <UvCameraControlSelector
      onCameraSelected={handleCameraSelected}
      hiddenModes={props.hiddenModes}
    />
  );
};
